(ns hai.admin-ui.users.groups.edit
  "User groups edit page"
  (:require
   [field :as-alias field]
   [hai-model.model :as model]
   [hai.sharing.components :as sharing.components]
   [hai.admin-ui.users.groups.components :as components]
   [hai.ui.components :as c]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.input :as input]
   [hai.ui.components.page :as c.page]
   [hai.ui.rf-sugar :refer [<s >e defsub]]
   [hai.web-app.components.form :as form-old]
   [hai.web-app.layout :as layout]
   [lambdaisland.ornament :as o]))

(o/defstyled render :div
  :flex :flex-col :gap-3
  :w-100
  [:.buttons :flex :flex-row :gap-3]
  ([{:form/keys [fields valid? on-submit submitting?] :as form-props}]
   (let [{:group/keys [display-name description]} fields]
     [:<>
      [:div
       [form/label display-name]
       [input/field display-name]]
      [:div
       [form/label description]
       [input/field description]]
      [:div.buttons
       [c/Button
        {:disabled (or (not valid?)
                       submitting?)
         :on-click on-submit
         :size "2"}
        "Update"]
       [c/Button
        {:disabled submitting?
         :size "2"
         :color "crimson"
         :variant "outline"}
        "Cancel"]]])))

(defsub :group
  [db id]
  (let [id (-> (or id (get-in db [:routing/current-route :path-params :group/uuid]))
               (uuid))]
    (get-in db [:group/uuid id])))

(o/defstyled user-form form-old/form
  ([group]
   [form/component
    {:id ::form
     :render render
     :schema model/Organisation
     :initial-value group
     :on-submit (fn [group]
                  (>e [:resolve [(list 'group/update group)]
                       ;; TODO form validation and error states
                       {:on-success-fx [[:dispatch [:form/submitted ::form]]
                                        [:dispatch [:routing/navigate [:user/groups]]]]}]))}]))

(defn top-bar-menu
  [{:group/keys [display-name] :as _group}]
  (let [route @(<s :routing/current-route-name)]
    [:<>
     [layout/breadcrumbs
      {:breadcrumbs [display-name (case route
                                    :groups/edit "Edit"
                                    :user.groups/sharing "Sharing")]}]
     [layout/heading
      {:label (case route
                :groups/edit (str "Edit " display-name)
                :user.groups/sharing (str "Share " display-name))}]
     [layout/top-bar-menu
      {:nav [{:title "Edit"
              :route-name :groups/edit}
             {:title "Sharing"
              :route-name :user.groups/sharing}]}]]))

(defn page
  [_]
  (when-let [group @(<s :group)]
    [layout/page
     [top-bar-menu group]
     [layout/content
      [user-form group]
      [:div
       [c/Heading "Members"]
       [components/group-members-table group]]]]))

(defn sharing
  [_]
  (when-let [group @(<s :group)]
    [layout/page
     [top-bar-menu group]
     [layout/content
      [:div
       [c.page/heading {:text "Sharing"}]
       [sharing.components/permissions-table group]]]]))

(defn routes
  []
  [["/edit"
    {:breadcrumbs [:user/groups]}
    ["/{group/uuid}"
     {:name :groups/edit
      :view page
      :controllers [{:parameters {:path [:group/uuid]}
                     :start (fn [{group :path}]
                              (>e [:entity/resolve group]))}]}]
    ["/{group/uuid}/sharing"
     {:name :user.groups/sharing
      :view sharing
      :controllers [{:parameters {:path [:group/uuid]}
                     :start (fn [{group :path}]
                              (>e [:entity/resolve group]))}]}]]])
